/* eslint-disable @typescript-eslint/no-explicit-any */
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '@/components/layout/Index';
import { useEffect, useState } from 'react';
import WorkshopDetails from '@/components/ui/workshops/details/WorkshopDetails';
import { getWorkshopBySlug } from '@/sanity/client';
import Loader from '@/components/ui/Loader';

const WorkshopDetailsPage = () => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const [workshop, setWorkshop] = useState<any | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!id) {
			console.error('Workshop ID parameter is missing');
			navigate('/');
			return;
		}

		// Fetch workshop by slug from Sanity
		const fetchWorkshop = async () => {
			setLoading(true);
			setError(null);

			try {
				const foundWorkshop = await getWorkshopBySlug(id);

				if (foundWorkshop) {
					// Format the data to match the component's expected structure
					const formattedWorkshop = {
						...foundWorkshop,
						// Extract day, month, year from the date field
						day: foundWorkshop.date
							? new Date(foundWorkshop.date).getDate().toString()
							: '',
						month: foundWorkshop.date
							? new Date(foundWorkshop.date).toLocaleString('default', {
									month: 'short',
								})
							: '',
						year: foundWorkshop.date
							? new Date(foundWorkshop.date).getFullYear().toString()
							: '',
					};

					setWorkshop(formattedWorkshop);
				} else {
					console.error(`Workshop with slug ${id} not found`);
					setError('Workshop not found');
					// Show error message instead of redirecting
				}
			} catch (err) {
				console.error('Error fetching workshop:', err);
				setError('Failed to load workshop details');
			} finally {
				// Add a slight delay before finishing loading to ensure DOM has time to render
				setTimeout(() => {
					setLoading(false);
				}, 300);
			}
		};

		fetchWorkshop();
	}, [id, navigate]);

	if (loading) {
		return <Loader />;
	}

	if (error || !workshop) {
		return (
			<Layout>
				<div className='md:p-20 p-10'>
					<p>{error || 'Workshop not found'}</p>
					<button
						onClick={() => navigate('/')}
						className='self-start px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors'
					>
						← Back to Workshops
					</button>
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className='md:p-30 px-10 py-25'>
				<WorkshopDetails workshop={workshop} />
			</div>
		</Layout>
	);
};

export default WorkshopDetailsPage;
